const VERSIONS = require('versions');
const config = require('core/config');
const ASSET_HOST = config.resources.assets.cdn || config.resources.assets.origin;

var DASH_REPLACE_REGEXP = new RegExp('[\\\\\\/, ]+', 'g'),
	STRIP_UNSAFE_REGEXP = new RegExp('[\\$&\\+\\:;\\=\\?"@\\<\\>#%\\{\\}\'\\.\\|\\^~\\[\\]]+', 'g');

const appHost = {
	[config.host]: true,
	'qa.readworks.org': true,
	'readworks.org': true,
	'www.readworks.org': true
};
module.exports = {
	getSearchParameter: function (name) {
		const queryString = window.location.search;

		if (!name || !queryString) return '';

		return decodeURIComponent((RegExp('[\\?&]' + name + '=' + '(.+?)(&|$)').exec(queryString) || [void 0, ''])[1]);
	},
	queryToObject: function (queryString) {
		if (queryString[0] === '?') {
			queryString = queryString.substring(1, queryString.length);
		}

		var pairs = queryString.split('&'),
			o = {};

		for (var i = 0, l = pairs.length; i < l; i++) {
			var tokens = pairs[i].split('=');

			o[tokens[0]] = tokens[1];
		}

		return o;
	},

	stringToURLFragment: function (s) {
		return s.replace(STRIP_UNSAFE_REGEXP, '').replace(DASH_REPLACE_REGEXP, '-');
	},

	getProductURL: function (product) {
		return '/article/' + this.stringToURLFragment(product.title) + '/' + product.uuid;
	},

	parseHash(hash = '') {
		hash = hash.replace(/#/, '').replace(/!/, '');
		let values = {};

		if (hash && hash.length) {
			let pairs = hash.split('/') || [];
			if (pairs && pairs.length) {
				values = pairs.reduce((acc, p) => {
					let keyValue = p && p.split(':');
					if (keyValue && keyValue.length === 2) {
						acc[keyValue[0]] = keyValue[1];
					}
					return acc;
				}, {});
			}
		}

		return values;
	},

	assetUrl(url) {
		const version = VERSIONS[url.replace('/assets/dist/', '')];

		return ASSET_HOST + url + (version ? '?v=' + version : '');
	},

	getAssetVersion(asset) {
		return VERSIONS[asset.replace('/assets/dist/', '')];
	},

	isHostedLink(link) {
		if (!link) {
			return false;
		}

		let hosted = false;
		let fullLink = null;
		let a = document.createElement('a');

		// anchor tag automatically handles relative links
		a.setAttribute('href', link);
		fullLink = a.href;

		if (fullLink) {
			let url = new URL(a.href);
			let host = url.host;
			hosted = !!appHost[host];
		}

		return hosted;
	}
};
